<template>
    <div id="history-error-weather">
    </div>
</template>

<script>
    export default {
        mounted() {
            this.queryHistoryErrorWeatherData()
        },
        methods: {
            queryHistoryErrorWeatherData() {
                this.$api.queryDeviceWeatherData().then(res => {
                    if (res.code === 200) {
                        let list = res.data || []
                        this.renderChart(list)
                    }
                })
            },
            renderChart(list){
                let myChart = this.$echarts.init(
                            document.getElementById("history-error-weather")
                        );
                        
                        myChart.setOption({
                            tooltip: {},
                            radar: {
                                indicator: list.map(item => {
                                    return {
                                        name:item.typeName,
                                        max:Math.max.apply(null,list.map(item => item.count))
                                    }
                                }),
                                radius: 55
                            },
                            series: [{
                                type: "radar",
                                data: [{
                                    value: list.map(item => item.count),
                                    name:'历史异常天气次数'
                                }],
                                areaStyle: {
                                    color: "rgba(255,0,0,0.2)"
                                }
                            }]
                        });
                        window.addEventListener("resize", function() {
                            myChart.resize();
                        });
            }
        }
    }
</script>